import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteTipoDeAnuncio, getTiposDeAnuncios, patchTipoDeAnuncio, postTipoDeAnuncio,
} from 'api/catalogos/tiposDeAnuncios';

// eslint-disable-next-line react/prop-types
const TiposDeAnuncios = ({ permission }) => (
  <PlainCRUD
    title="Tipo de Anuncio"
    permission={permission}
    get={getTiposDeAnuncios}
    post={postTipoDeAnuncio}
    patch={patchTipoDeAnuncio}
    delete={deleteTipoDeAnuncio}
    withoutState
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
      {
        name: 'observaciones',
        label: 'Observaciones',
        type: 'textarea',
        colWidth: 200,
        autoSize: { minRows: 3, maxRows: 4 },
      },
    ]}
  />
);

export default TiposDeAnuncios;
